import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from 'components/Footer';
import Header from 'components/Header';
import HomePage from 'pages/HomePage'; // Главная страница
// import AboutPage from 'pages/AboutPage'; // Страница "О нас"
import NotFoundPage from 'pages/NotFoundPage'; // Страница 404
import 'styles/header.css';
// import 'styles/main.css';
// import 'styles/footer.css';
import 'styles/globals.css';
import BusinessCourse from 'pages/BusinessCourse';
import ExamCourseInEnglis from 'pages/ExamCourseInEnglis';
import CourseForTheOGE from 'pages/CourseForTheOGE';
import SpokenEnglish from 'pages/SpokenEnglish';
import CourseForAdults from 'pages/CourseForAdults';
import CourseForChildren from 'pages/CourseForChildren';
import CourseForTraveling from 'pages/CourseForTraveling';
const Layout = () => {
    return (
        <div className="layout">
            <Router>
                <Header/>
                <RoutesConfig/>
                <Footer/>
            </Router>
        </div>
    );
}
const RoutesConfig: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/Basic-English-course-for-children" element={<CourseForChildren />} />
            <Route path="/Basic-English-course-for-Adults" element={<CourseForAdults />} />
            <Route path="/Spoken-English" element={<SpokenEnglish />} />
            <Route path="/English-Express-Course-for-Traveling-Abroad" element={<CourseForTraveling />} />
            <Route path="/The-course-of-preparation-for-the-OGE" element={<CourseForTheOGE />} />
            <Route path="/English-Exam-Preparation-Course" element={<ExamCourseInEnglis />} />
            <Route path="/Business-course" element={<BusinessCourse />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
};

export default Layout;